module.exports = __webpack_public_path__ + "img/about.5ec2a908.png";